<template>
   <div class="sidebar bg-gray-600" :style="{ width: sidebarWidth }">
    <div class="block w-full h-20 mb-5 bg-gray-700">
      <span ref="collapseButton"
        class="collapse-icon"
        v-if="collapsed==false"
        @click="toggleSidebar">
        <i class="fas fa-close fa-2x text-white"></i>
      </span>
    </div>
    <AppSidebarLink v-for="menu in menues" 
    :key="menu.id" 
    :id="menu.id" 
    :to="menu.to" 
    :icon="menu.icon" 
    @parentMenuClose="toggleSidebar()">{{menu.name}}</AppSidebarLink>
    
  </div>
  <div class="close-sidebar absolute w-full h-full"
    v-if="collapsed==false"
    @click="toggleSidebar()">
  </div>
</template>
<script>
import AppSidebarLink from './AppSidebarLink'
import { collapsed, toggleSidebar, sidebarWidth } from './state'

export default {
  components: { 
    AppSidebarLink
  },
  setup() {
    return { collapsed, toggleSidebar, sidebarWidth }
  },
  data(){
    return{
      menues: [
        {id:'Notifications', icon:'lni lni-popup', name:'Notificaciones', to:'/Notificaciones'},
        {id:'Collections', icon:'lni lni-revenue', name:'Cobranzas', to:'/Cobranzas'},
        {id:'Sales', icon:'lni lni-dollar', name:'Ventas', to:'/Ventas'},
        {id:'Accounts', icon:'lni lni-user', name:'Cuentas', to:'/Cuentas'},
        {id:'Activities', icon:'lni lni-control-panel', name:'Actividades', to:'/Actividades'},
        {id:'Cases', icon:'lni lni-package', name:'Casos', to:'/Casos'},
        {id:'OnBoarding', icon:'lni lni-calculator', name:'On Boarding', to:'/OnBoarding'},
        {id:'Reports', icon:'lni lni-stats-up', name:'Reportes', to:'/Reportes'},
        {id:'Logout', icon:'lni lni-exit', name:'Cerrar sesión', to:'/Logout'},
      ]
    }
  }
}
</script>
<style scoped>
.close-sidebar{
  z-index: 9997;
}
.sidebar {
  float: left;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  bottom: 0;  
  transition: 0.2s ease;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.collapse-icon {
  position: absolute;
  top: 10px;
  right: 20px;
  transition: 0.2s linear;
  z-index: 9;
  font-size: 1rem;
}
</style>